mainHandler = {
  $openSmallNav               : $('[data-nav-toggle-mobile]'),
  $closeSmallNav              : $('[data-nav-close-mobile]'),
  $smallNavPanel              : $('#small-nav-panel'),
  $internalNav                : $('.panel-internal-nav'),
  $languageSwitchContainer    : $('.language-switch-container'),
  $navToggle                  : $('[data-nav-toggle]'),
  $navToggleMobileSub         : $('[data-nav-toggle-mobile-sub]'),
  $subNavContainer            : $('.sub-nav-container'),
  $smallSubNavContainer       : $('.small-sub-nav-container'),
  $lastFocusedElement         : null,
  current_language            : '',    
  $logoContainer              : $('.logo-container'),
  $imageResize                : $('[data-image-resize]'),
  $body                       : $('body'),
  $trpDisabledLanguage        : $('.trp-ls-disabled-language'),
  $shrCarousel                : $('.shr-carousel'),
  $shrCopyLink                : $('.shr-copy-link'),
  $masonryGrid                : $('.masonry-grid'),
  $parentNav                  : [],
  
  internalLinkScroll: function(hash, $duration = 800, headHeightAddon = 0 ) {
    if (hash && hash.includes('#')) {
      var arrHash = hash.split('#');
      var $hashEl = $('#'+arrHash[1]);

      if ($hashEl.hasClass('accordion-item')) {
        $hashEl.siblings('.accordion-item.is-active').find('.accordion-title').click();
        $hashEl.find('.accordion-title').click();

        $hashEl = $hashEl.parents('.accordion');
      } 
      
      if ($hashEl.length !== 0) {
        var headHeight  = $('header').outerHeight();
        var scrollVal   = $hashEl.offset().top - headHeight + headHeightAddon;

        $('html, body').animate({
          scrollTop: scrollVal,
        }, $duration);


        setTimeout(function() {
          if (window.location.hash != hash) 
            window.location.hash = hash;
        }, ($duration / 2));
      }
    }
  },
  
  gt_get_cookie: function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },

  defaultLineColor: function(){
    var self = this;
    if (self.$internalNav.length > 0) {
      var $firstObj = $(self.$internalNav.find('.internal-nav')[0]);
      var color = $firstObj.find('.nav-item').data('line-color');
      if (color) {
        $firstObj.parent().removeClass('yellow');
        $firstObj.parent().addClass(color);
      }
    }
  },

  setMainHeight: function() {
    var self = this;

    var headHeight = $('header').outerHeight();
    $('main.pad-header-top').css('padding-top', headHeight);
  },

  setNavPadTop: function() {
    var self = this;

    if (self.$internalNav.length > 0) {
      self.$internalNav.each(function() {
        var $section = $(this).parent().find('section');
        if ($section.length > 0) { 
          var minVal = 16;

          if ($section.first().hasClass('minus-pad')) minVal = -20;
          if ($section.first().hasClass('full-pad')) minVal = -6;

          var firstSectionPadding = parseFloat($section.first().css('padding-top').replace('px', '')) - minVal;
        
          $(this).find('.grid-panel').css('padding-top', firstSectionPadding);
        }
      });
    }
  },

  setLogo: function() {
    var self = this;

    if (self.$logoContainer.length > 0) {
      var logoPos = self.$logoContainer.position().top + self.$logoContainer.outerHeight();
      var docPos = $(document).scrollTop();
      var scrollLogo = logoPos + docPos;
      var footPos = $('footer').position().top;

      if (scrollLogo > footPos && !self.$logoContainer.hasClass('hide')) {
        self.$logoContainer.addClass('hide');
      } else if (scrollLogo < footPos && self.$logoContainer.hasClass('hide')) {
        self.$logoContainer.removeClass('hide');
      }
    }
  },

  clearElementClassContain: function($obj, $needle) {
    var self = this;
    var accClass = [];

    if ($obj.length > 0) {
      var arrClassName = $obj.attr('class').split(" ");
     
      $.each(arrClassName, function (index, name) {
        if (!(name.includes($needle))) {
          accClass.push(name);
        }
      });
    }

    return accClass.join(" ");
  },

  setNavCondition: function() {
    var self = this;
    if (self.$internalNav.length > 0) {
      self.$internalNav.each(function() {
        var nav = this;
        setTimeout(() => {
          if ($(nav).find('[data-line-color].is-active').length > 0) {
            $(nav).find('[data-line-color].is-active').each(function() {
              var lineColor = $(this).data('line-color');

              if (!lineColor) lineColor = 'yellow';

              if (lineColor) {
                if (!$(nav).find('.nav-line').hasClass('line-'+lineColor)) {
                  $(nav).find('.nav-line').attr('class', self.clearElementClassContain($(nav).find('.nav-line'), 'line-'));
                  $(nav).find('.nav-line').addClass('line-'+lineColor);
                }
              }
            });
          }

          if ($(nav).find('[data-text-color].is-active').length > 0) {
            $(nav).find('[data-text-color].is-active').each(function() {
              var textColor = $(this).data('text-color');
                
              if (textColor) {
                if (!$(nav).find('.internal-nav-container').hasClass('base-clr-'+textColor)) {
                  $(nav).find('.internal-nav-container').attr('class', self.clearElementClassContain($(nav).find('.internal-nav-container'), 'base-clr-'));
                  $(nav).find('.internal-nav-container').addClass('base-clr-'+textColor);
                }
              } else {
                $(nav).find('.internal-nav-container').attr('class', self.clearElementClassContain($(nav).find('.internal-nav-container'), 'base-clr-'));
              }
            });
          }
          
        }, 300); 

        if ($(nav).find('.nav-child-item').length > 0) {
          $(nav).find('.internal-nav').each(function() {
            if ($(this).find('.nav-child-item.is-active').length == 0) {
              $(this).find('.nav-parent').removeClass('is-active');
            } else {
              $(this).find('.nav-parent').addClass('is-active');
            }
          });
        }

        var $activeItem = $(this).find('.nav-item.is-active');
        if ($activeItem.length > 0) {
          var $magellanTarget = $('section[data-magellan-target="'+$activeItem.attr('href').replace("#", "")+'"]');
          if ($magellanTarget.length > 0) {
            if ($magellanTarget.is('.bg-color-nero')) {
              $activeItem.parents('.panel-internal-nav').addClass('inverse');
            } else {
              $activeItem.parents('.panel-internal-nav').removeClass('inverse');
            }
          }
        }
      });
    }
  },

  setImageSize: function() {
    var self = this;

    self.$imageResize.each(function() {
      var size = parseFloat($(this).data('image-resize'));
      var mediaOn = $(this).data('resize-on');
      var currWidth = $(this).width();
      var newHeight = currWidth * size;

      if (!mediaOn) {
        mediaOn = 'medium';
      }
      
      if (Foundation.MediaQuery.is(mediaOn)) {
        $(this).css('height', newHeight);
      }
    });
  },

  setGlobalStyle: function() {
    var self = this;
    
    self.$body.css('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');
    self.$body.css('--window-height', window.innerHeight + 'px');
    self.$body.css('--min-height', (window.innerWidth * 0.56) + 'px');
  },

  setImgSize: function(specificEl = null) {
    var el = (specificEl) ? $(specificEl) : $('[data-img-aspect-ratio]');
    if (el.length > 0) {
      el.each(function() {
        var imgWidth = $(this).width();
        var ratio	 = $(this).data('img-aspect-ratio');
  
        $(this).css('height', (imgWidth / ratio) + 'px')
      });
    }
  },

  _closeAllSubmenus: function() {
    var self = this;
    self.$navToggle.attr('aria-expanded', 'false');
    self.$subNavContainer.removeClass('is-visible');
  },

  _closeMobileNav: function() {
    var self = this;
    self.$smallNavPanel.removeClass('is-showing');
    $('body').removeClass('disable-scroll-body');
    self.$smallNavPanel.attr('aria-hidden', 'true');
    self.$openSmallNav.attr('aria-expanded', 'false');
    
    // Remove focusable elements from tab order when panel is hidden
    self.$smallNavPanel.find('a, button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
    
    // Return focus to the toggle button
    if (self.$lastFocusedElement && self.$lastFocusedElement.length) {
      self.$lastFocusedElement.focus();
      self.$lastFocusedElement = null;
    } else {
      self.$openSmallNav.focus();
    }
  },

  masonryInit: function() {
    var self = this;
    
    if (Foundation.MediaQuery.atLeast('medium')) {
      var $grid = self.$masonryGrid.masonry({
        // options
        itemSelector: '.mason-item',
        horizontalOrder: true
      });

      $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
        });

      /* setTimeout(function() {
        $(window).resize();
      }, 500); */
    }
  },
  
  init : function() {
    var self = this;
    var headEl = document.querySelector("header");
    var headroom  = new Headroom(headEl, {
      offset : 100,
    });
    headroom.init();
    self.setGlobalStyle();
    self.setImgSize();
    self.masonryInit();

    if (self.$parentNav.length > 0) {
      self.$parentNav.on('click', function(e) {
        e.preventDefault();
      });
    }
    
    if (self.$shrCarousel.length > 0) {
      self.$shrCarousel.each(function() {
        var carouselOption = {
          cellSelector: '.shr-carousel-cell',
          cellAlign: 'left',
          pageDots: true,
          fade: false,
          wrapAround: true,
          prevNextButtons: true,
          draggable: false,
        };

        $(this).flickity(carouselOption);
      });
    }

    if (self.$shrCopyLink.length > 0) {
      self.$shrCopyLink.each(function() {
        $(this).find('.copy-trigger').on('click', function(e) {
          e.preventDefault();
          var elCopy = $(this);
          var copyText = elCopy.siblings('a').attr('href');
          var currTooltip = elCopy.find('.ct-tooltip').html();
         
          document.addEventListener('copy', function(e) {
             e.clipboardData.setData('text/plain', copyText);
             e.preventDefault();
          }, true);
         
          document.execCommand('copy');

          elCopy.find('.ct-tooltip').html('Link copied.');
          elCopy.addClass('show-tooltip');
          setTimeout(function() {
            elCopy.removeClass('show-tooltip');

            setTimeout(function() {
              elCopy.find('.ct-tooltip').html(currTooltip);
            }, 200);
          }, 2000);
        });
      });
    }

    // ========================================
    // WCAG: Desktop dropdown nav keyboard toggle
    // ========================================
    self.$navToggle.on('click', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var $submenu = $('#' + $btn.attr('aria-controls'));
      var isOpen = $btn.attr('aria-expanded') === 'true';
      
      // Close all other open submenus first
      self.$navToggle.not($btn).attr('aria-expanded', 'false');
      self.$subNavContainer.not($submenu).removeClass('is-visible');
      
      // Toggle this one
      $btn.attr('aria-expanded', !isOpen);
      $submenu.toggleClass('is-visible');
    });

    self.$navToggle.on('keydown', function(e) {
      var $btn = $(this);
      var $submenu = $('#' + $btn.attr('aria-controls'));
      var $parent = $btn.closest('.header-nav-item');
      var $menuItems = $parent.closest('.header-nav-container').find('.header-nav-item');

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if ($btn.attr('aria-expanded') === 'true') {
            // Move focus to first submenu link
            $submenu.find('.sub-nav-link').first().focus();
          }
          break;
        case 'ArrowUp':
          e.preventDefault();
          if ($submenu.hasClass('is-visible')) {
            // Move focus back to toggle button
            $btn.focus();
          }
          break;
        case 'Escape':
          e.preventDefault();
          $btn.attr('aria-expanded', 'false');
          $submenu.removeClass('is-visible');
          $btn.focus();
          break;
      }
    });

    // Close submenu when pressing Escape on a sub-nav link
    $(document).on('keydown', '.sub-nav-link', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        var $submenu = $(this).closest('.sub-nav-container');
        var $toggle = $('[aria-controls="' + $submenu.attr('id') + '"]');
        $submenu.removeClass('is-visible');
        $toggle.attr('aria-expanded', 'false').focus();
      }
    });

    // Close submenus when clicking outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.header-nav-item').length) {
        self._closeAllSubmenus();
      }
    });

    // Close submenu when focus moves to a different nav item (Tab key)
    $(document).on('focusin', function(e) {
      var $focusedItem = $(e.target).closest('.header-nav-item');
      var $openSubmenu = self.$subNavContainer.filter('.is-visible').first();
      
      if ($openSubmenu.length) {
        var $openParent = $openSubmenu.closest('.header-nav-item');
        // If the focused element is not inside the same header-nav-item, close all
        if (!$focusedItem.length || $focusedItem[0] !== $openParent[0]) {
          self._closeAllSubmenus();
        }
      }
    });

    // ========================================
    // WCAG: Get Help dropdown keyboard toggle
    // ========================================
    $(document).on('click', '[data-get-help-toggle]', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var $menu = $btn.siblings('[data-get-help-menu]');
      var isOpen = $btn.attr('aria-expanded') === 'true';
      
      $btn.attr('aria-expanded', !isOpen);
      $btn.closest('.btn-get-help').toggleClass('active');
      
      if (!isOpen) {
        // Focus first menu item
        setTimeout(function() {
          $menu.find('a').first().focus();
        }, 50);
      }
    });

    $(document).on('keydown', '[data-get-help-toggle]', function(e) {
      var $btn = $(this);
      var $menu = $btn.siblings('[data-get-help-menu]');
      
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if ($btn.attr('aria-expanded') === 'true') {
            $menu.find('a').first().focus();
          } else {
            $btn.click();
          }
          break;
        case 'Escape':
          e.preventDefault();
          $btn.attr('aria-expanded', 'false');
          $btn.closest('.btn-get-help').removeClass('active');
          $btn.focus();
          break;
      }
    });

    // Close Get Help menu when focusing outside
    $(document).on('focusin', function(e) {
      var $getHelp = $('[data-get-help].active');
      if ($getHelp.length && !$(e.target).closest('[data-get-help]').length) {
        $getHelp.find('[data-get-help-toggle]').attr('aria-expanded', 'false');
        $getHelp.removeClass('active');
      }
    });

    // Close submenu when Escape pressed on a Get Help menu link
    $(document).on('keydown', '[data-get-help-menu] a', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        var $getHelp = $(this).closest('[data-get-help]');
        $getHelp.find('[data-get-help-toggle]').attr('aria-expanded', 'false').focus();
        $getHelp.removeClass('active');
      }
    });

    // ========================================
    // WCAG: Mobile nav keyboard & focus management
    // Sync tabindex on focusable children when panel opens/closes
    // so aria-hidden elements never contain focusable content.
    // ========================================
    function syncMobileNavTabindex(isOpen) {
      self.$smallNavPanel.find('a, button, input, select, textarea, [tabindex]').each(function() {
        if (isOpen) {
          $(this).removeAttr('tabindex');
        } else {
          $(this).attr('tabindex', '-1');
        }
      });
    }

    self.$openSmallNav.on('click', function(e) {
      e.preventDefault();
      self.$lastFocusedElement = $(document.activeElement);
      var $btn = $(this);
      
      self.$smallNavPanel.addClass('is-showing');
      $('body').addClass('disable-scroll-body');
      
      // ARIA state
      $btn.attr('aria-expanded', 'true');
      self.$smallNavPanel.attr('aria-hidden', 'false');
      
      // Enable keyboard access for all focusable elements inside
      syncMobileNavTabindex(true);

      // Move focus to first focusable element inside panel
      setTimeout(function() {
        self.$smallNavPanel.find('a, button').first().focus();
      }, 100);
    });

    self.$closeSmallNav.on('click', function(e) {
      e.preventDefault();
      self._closeMobileNav();
    });

    // Close mobile nav with Escape
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && self.$smallNavPanel.hasClass('is-showing')) {
        self._closeMobileNav();
      }
    });

    // Mobile submenu toggles
    self.$navToggleMobileSub.on('click', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var $submenu = $('#' + $btn.attr('aria-controls'));
      var isOpen = $btn.attr('aria-expanded') === 'true';
      
      $btn.attr('aria-expanded', !isOpen);
      $submenu.slideToggle(300);
    });

    self.current_language = self.gt_get_cookie('googtrans').split('/').pop();
    self.$languageSwitchContainer.addClass(self.current_language);
    self.$languageSwitchContainer.find('.trp-ls-shortcode-language').children().each(function(){
      $(this).text($(this).attr('title'));    
    })

    
    //self.$trpDisabledLanguage.addClass('bg-base-color');

    self.$smallNavPanel.each(function() {
      $(this).on('click', 'a:not([data-nav-close-mobile]):not(.trp-ls-disabled-language)', function() {
        self._closeMobileNav();
      });
    });

    $('a:not(.tabs)').on('click', function(e) {
      var href = $(this).attr('href');
      self.internalLinkScroll(href);
    });

    $('.panel-close-single').on('click', 'a.close-single-panel' , function(e) {
      e.preventDefault();
      if (!$(this).parent().hasClass('skip-refresh'))
        history.go(-1);
    });
    
    var tempHeight = window.height;
    var firstLoad = true;
    $(window).on('resize', function(e) {
      if (((tempHeight != window.height) || (firstLoad)) && Foundation.MediaQuery.only('small')) {
        /* if (self.$smallNavPanel.length > 0) {
          var screenHeight = window.outerHeight;
          self.$smallNavPanel.css({
            //'height' : screenHeight,
            'min-height' : screenHeight,
          });
          firstLoad = false;  
        } */
      }

      self.setMainHeight();
      self.setNavPadTop();
      self.setImageSize();
      self.setGlobalStyle();
      self.setImgSize();
    });

    $(window).on('scroll', function(e) {
      self.setLogo();
      self.setNavCondition();
    });

    $(window).load(function() {
      var bodyClass = $('body').attr('class');
      if (bodyClass.includes('translatepress-es')) {
        $('body').find('.gform_wrapper').addClass('is-es');
      }
      self.setImageSize();
      self.setLogo();
      self.setNavCondition();
      self.defaultLineColor();
    });

    var hash = window.location.hash;
    self.internalLinkScroll(hash); 
    self.setMainHeight();
    self.setNavPadTop();

    self.$languageSwitchContainer.on('click', 'a', function(){
      self.$languageSwitchContainer.removeClass('es');
      self.$languageSwitchContainer.find('.trp-language-switcher').toggleClass('active');
      
      setTimeout(() => {
        self.current_language = self.gt_get_cookie('googtrans').split('/').pop();
        self.$languageSwitchContainer.addClass(self.current_language);
      }, 500);
    })

    $('html').click(function(e) {                    
      if(!$(e.target).hasClass('trp-language-switcher') && !($(e.target).hasClass('trp-ls-disabled-language'))) {
        if ($('html').hasClass('no-touchevents')) {
          self.$languageSwitchContainer.find('.trp-language-switcher').removeClass('active');
        }   
      }
    }); 

    $(document).on('click', '.btn-share', function(e){
      e.preventDefault();
      $(this).toggleClass('active');
    })

    $(document).on('mouseenter', '.btn-share', function(){
      $(this).addClass('active');
    }).on('mouseleave', '.btn-share', function(){
      $(this).removeClass('active');
    })

    $(document).on('click', '[data-gallery-trigger]', function(e) {
      e.preventDefault();
      var $trigger = $(this);
      var $container = $trigger.closest('[data-gallery-container]');
      var visibleRows = parseInt($container.data('visible-rows')) || 2;
      var $extraRows = $container.find('.bottle-event-gallery-row').slice(visibleRows);
      
      $extraRows.toggleClass('hide');
      $trigger.toggleClass('opened');
      
      if ($trigger.hasClass('opened')) {
        $trigger.text('Less');
      } else {
        $trigger.text('More!');
      }
    });

    // ========================================
    // WCAG: Initialize mobile nav — panel starts hidden so
    // all focusable children must have tabindex="-1" from the start.
    // ========================================
    if (self.$smallNavPanel.length) {
      self.$smallNavPanel.find('a, button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
    }

    // ========================================
    // WCAG: Hide reCAPTCHA iframe/badge from accessibility tree
    // Google injects the reCAPTCHA iframe asynchronously inside
    // GravityForms' .ginput_recaptcha container. Use MutationObserver
    // to catch it whenever it appears (even on local where src may be empty).
    // ========================================
    function hideRecaptcha($container) {
      // Target any iframe or .grecaptcha-badge inside reCAPTCHA field containers
      $container.find('.ginput_recaptcha iframe, .ginput_recaptcha .grecaptcha-badge').each(function() {
        $(this).attr('aria-hidden', 'true').attr('tabindex', '-1');
      });
    }

    $(document).on('gform_post_render', function() {
      var $form = $('.gform_wrapper');
      if (!$form.length) return;

      // Run immediately on any existing reCAPTCHA elements
      hideRecaptcha($form);

      // Watch for asynchronously injected reCAPTCHA iframes/badges
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            var $node = $(node);
            if ($node.is('.ginput_recaptcha') || $node.closest('.ginput_recaptcha').length || $node.find('.ginput_recaptcha').length) {
              hideRecaptcha($form);
            }
          });
        });
      });

      observer.observe($form[0], {
        childList: true,
        subtree: true
      });
    });
  }
}